export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^\d{10}$/,
  DECIMAL_AMOUNT: /^(?:[1-9][0-9]*|[1-9][0-9]*\.[0-9]+)$/,
};
